// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.zengo",
    name: "Zengo Wallet",
    homepage: "https://zengo.com/",
    image_id: "6133c399-ae32-4eba-0c5a-0fb84492bf00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/zengo-crypto-bitcoin-wallet/id1440147115",
        android: "https://play.google.com/store/apps/details?id=com.zengo.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "zengo://get.zengo.com/",
        universal: "https://get.zengo.com/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map